module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "with-content": true,
      "fix-height": _vm.fixHeight,
      "theme": true,
      "max-width": _vm.maxWidth,
      "min-width": _vm.minWidth
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('main', {
    class: {
      overlay: _vm.overlay, fixWidth: _vm.fixWidth
    },
    style: (_vm.mainStyle)
  }, [_c('div', {
    staticClass: "overlay-container"
  }, [_vm._t("overlay")], 2), _vm._v(" "), _vm._t("main")], 2), _vm._v(" "), _c('footer', [_vm._t("footer")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca696e46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ModalTheme.vue
// module id = 3362
// module chunks = 0